import React from "react";
import { Button, Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./StandardModal.scss";

// Shared modal used across the Campaigns, Audience and Surveys sections so that
// every dialog shares the same title treatment (color/font of the design's
// add-survey-modal title) and the same footer buttons.
//
// Two ways to render actions:
//  1. Pass `primaryText` (and optionally `cancelText`) to get the standardized
//     footer: an outlined "cancel" button + a filled primary button.
//  2. Pass a custom `actions` node (or embed buttons in `children`) for modals
//     whose actions don't fit the two-button pattern.
const StandardModal = ({
   open,
   onCancel,
   title,
   children,
   width = 600,
   className = "",
   titleClassName = "",
   centerTitle = false,
   // Standardized footer
   primaryText,
   cancelText = "Cancel",
   onPrimary,
   primaryLoading = false,
   primaryDisabled = false,
   primaryDanger = false,
   cancelDisabled = false,
   hideCancel = false,
   // Escape hatch for non-standard footers
   actions,
   ...rest
}) => {
   const standardActions =
      primaryText !== undefined ? (
         <div className="standard-modal__actions">
            {!hideCancel && (
               <Button
                  className="standard-modal__btn standard-modal__btn--cancel"
                  onClick={onCancel}
                  disabled={cancelDisabled || primaryLoading}
               >
                  {cancelText}
               </Button>
            )}
            <Button
               type="primary"
               className={`standard-modal__btn standard-modal__btn--primary${
                  primaryDanger ? " standard-modal__btn--danger" : ""
               }`}
               onClick={onPrimary}
               loading={primaryLoading}
               disabled={primaryDisabled}
            >
               {primaryText}
            </Button>
         </div>
      ) : null;

   return (
      <Modal
         open={open}
         onCancel={onCancel}
         footer={null}
         width={width}
         // centered
         className={`standard-modal ${className}`.trim()}
         closeIcon={<CloseOutlined className="standard-modal__close-icon" />}
         {...rest}
      >
         {title !== undefined && title !== null && (
            <h2
               className={`standard-modal__title${
                  centerTitle ? " standard-modal__title--center" : ""
               } ${titleClassName}`.trim()}
            >
               {title}
            </h2>
         )}
         {children}
         {actions ?? standardActions}
      </Modal>
   );
};

export default StandardModal;
